import service from './service';

const apiService = service('https://reports-service.re2recruit.com/');

export const addReport = (type: string | undefined, businessIds: string[]) =>
	apiService.post('/api/report/add', {
		type,
		businessIds
	});

export const getReports = (
	startDate: Date,
	endDate: Date,
	userEmails: string | string[],
	listId?: string,
	method?: string,
	locationId?: string
): any => {
	const startDateTime = startDate.getTime();
	const endDateTime = endDate.getTime();

	return apiService.get(`/api/report/get`, {
		params: {
			startDate: startDateTime,
			endDate: endDateTime,
			userEmails: Array.isArray(userEmails) ? userEmails : [userEmails],
			listId,
			method,
			locationId
		}
	});
};
